export enum StepIds {
  Details = 'Details',
  Skills = 'Skills',
  People = 'People',
  Summary = 'Summary',
}